import { mount } from "svelte";
import App from "./App.svelte";
import "./app.css";
import { installPinStufe } from "./lib/pin-stufe";
import { initPrefsFromCache } from "./lib/prefs.svelte";
import { startPWA } from "./lib/pwa.svelte";
import { initRangeFill } from "./lib/range-fill";
import { starteTakt } from "./lib/takt";
import { startViewportSync } from "./lib/viewport-sync";

// Viewport-Sync ZUERST: pflegt --app-vh + --app-vv-bottom CSS-Variablen
// gegen das echte visualViewport. Behebt iOS-PWA-Bug wo fixed-bottom-
// Elemente beim Cold-Start zu hoch landen.
startViewportSync();

// Alles, was „läuft", pulst im selben Takt (lib/takt.ts).
starteTakt();

// Die PIN-Abfrage der Schutzstufe hängt unter allen Anfragen -- vor dem
// ersten fetch, damit keine an ihr vorbeiläuft (lib/pin-stufe.ts).
installPinStufe();

// User-Prefs aus localStorage hydratisieren BEVOR App rendert -- damit
// Theme/Sprache/bg sofort stehen und kein Flash entsteht. Server-Sync
// kommt nach Auth-OK in App.svelte (loadPrefsFromServer).
initPrefsFromCache();

// Service-Worker registrieren + PWA-Status erfassen. Laeuft async im
// Hintergrund; reaktive Werte stehen Settings/Push zur Verfuegung.
startPWA();

// Hintergrund-Layer (Canvas + Ambient-Glow) wandern in App.svelte's
// startBootStreams -- nur nach erfolgreichem Auth gemountet, damit
// die Login-Seite kein persoenliches Theme zeigt und beim ersten Paint
// kein "Dashboard-Hintergrund kurz sichtbar"-Flackern entsteht.

const target = document.getElementById("app");
if (!target) throw new Error("missing #app root");

mount(App, { target });

// Range-Slider global mit Accent-Fill ausstatten (delegiert + Observer),
// nach dem Mount, damit document.body existiert. Deckt alle Slider ab.
initRangeFill();
